export enum BatcherState {
    wait,
    inactive,
}

type CallbackFunctionVariadic = (...args: any[]) => void;

export class Batcher {
    private static __instance__: Batcher;

    private _handler: CallbackFunctionVariadic;
    private _waitingTime: number;
    private _capacity: number;
    private _once: boolean;
    private _state: BatcherState;
    private _timer: ReturnType<typeof setTimeout>;
    private _listData: Array<Parameters<CallbackFunctionVariadic>> = [];

    constructor(func: CallbackFunctionVariadic, waitingTime = 1000, capacity = 5, once = true) {
        if (Batcher.__instance__) return Batcher.__instance__;
        Batcher.__instance__ = this;
        this._handler = func;
        this._waitingTime = waitingTime;
        this._capacity = capacity;
        this._once = once;

        if (this._waitingTime > 0) {
            this._state = BatcherState.wait;
            this._startTimer();
        }
        this._startListenCloseTab();

        return;
    }

    public get state() {
        return this._state;
    }

    public get pushData() {
        return this.add.bind(this);
    }

    private _startTimer() {
        if (this._waitingTime <= 0) return;
        if (this._timer) clearTimeout(this._timer);
        this._timer = setTimeout(() => {
            if (this._state === BatcherState.inactive) return;
            this._handle();
        }, this._waitingTime);
    }

    private _startListenCloseTab() {
        //  Экстренная отправка всего chunk'а
        window.addEventListener('beforeunload', () => {
            this._handle();
            return false;
        });
    }

    public add(...args: Parameters<CallbackFunctionVariadic>) {
        if (this._state === BatcherState.inactive) return this._handler(...args);

        this._listData.push(args);
        if (this._listData.length >= this._capacity) this._handle();
    }

    private _handle() {
        const snapshot = this._listData.slice();
        this._listData = [];
        if (this._once) this._state = BatcherState.inactive;
        if (snapshot.length) this._handler(...snapshot);
        if (!this._once) this._startTimer();
    }
}
